export default {
  DARK: {
    paragraph: p => p.accentWhite,
    iconColor: p => p.primaryLight,
    background: p => `${p.tertiaryDark}`,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    paragraph: p => p.primaryDark,
    iconColor: p => p.primaryDark,
    background: p => `${p.tertiaryLight}`,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    paragraph: p => p.tertiaryDark,
    iconColor: p => p.primaryDark,
    background: p => `${p.tertiaryExtraLight}`,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
